var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 94c25.957 0 47-21.043 47-47S79.957 0 54 0 7 21.043 7 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 14.2H93c-11.9 0-22.1 7.4-26.2 17.9L74.4 48h7.3c6.5 0 11.8-5.3 11.8-11.8l-.2-.5c4.1-1.9 7-6 7-10.8 0 0 5.6-4.1 5.6-10.7Z",
    fill: "#8DD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36c0 6.5-5.2 11.9-11.8 11.9h-7.3M67.2 32c4.1-10.5 14.2-17.9 26.1-18l12.9-.1c0 6.5-5.2 11.9-11.8 11.9h-5.1L67.2 32Zm33.5-7.3c0 6.5-5.2 11.9-11.8 11.9h-5.1l16.9-11.9Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2 14.5-12.9.1C1.3 21.1 7 25.3 7 25.3c0 4.8 2.9 8.9 7 10.7l-.2.5c0 6.5 5.4 11.8 11.9 11.8H33l7.6-15.9c-4.3-10.6-14.5-18-26.4-17.9Z",
    fill: "#8DD9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 36.4c0 6.5 5.4 11.8 11.9 11.8h7.3m7.6-16c-4.2-10.4-14.4-17.8-26.3-17.7l-12.9.1c0 6.5 5.4 11.8 11.9 11.8h5.1l22.2 5.8Zm-33.6-7c0 6.5 5.4 11.8 11.9 11.8h5.1l-17-11.8Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 78.6c16.016 0 29-12.984 29-29s-12.984-29-29-29c-16.017 0-29 12.984-29 29s12.983 29 29 29Z",
    fill: "#D5EFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m55.2 32.6 3.5 7.1c.2.5.7.8 1.2.8l7.9 1.1c1.3.2 1.8 1.7.9 2.6L63 49.7c-.4.4-.5.9-.4 1.4l1.3 7.8c.2 1.3-1.1 2.2-2.2 1.6l-7-3.7c-.5-.2-1-.2-1.4 0l-7 3.7c-1.1.6-2.5-.4-2.2-1.6l1.3-7.8c.1-.5-.1-1-.4-1.4l-5.7-5.5c-.9-.9-.4-2.5.9-2.6l7.9-1.1c.5-.1.9-.4 1.2-.8l3.5-7.1c.2-1.1 1.9-1.1 2.4 0ZM28.7 45l2.7 5.6c.2.4.5.6.9.7l6.1.9c1 .1 1.4 1.4.7 2.1l-4.4 4.3c-.3.3-.4.7-.3 1.1l1 6.1c.2 1-.9 1.7-1.8 1.3l-5.5-2.9c-.4-.2-.8-.2-1.1 0l-5.5 2.9c-.9.5-1.9-.3-1.8-1.3l1-6.1c.1-.4-.1-.8-.3-1.1L16 54.3c-.7-.7-.3-1.9.7-2.1l6.1-.9c.4-.1.7-.3.9-.7l2.7-5.6c.6-.9 1.9-.9 2.3 0Zm52.4 0 2.7 5.6c.2.4.5.6.9.7l6.1.9c1 .1 1.4 1.4.7 2.1l-4.4 4.3c-.3.3-.4.7-.3 1.1l1 6.1c.2 1-.9 1.7-1.8 1.3l-5.5-2.9c-.4-.2-.8-.2-1.1 0L74 67c-.9.5-1.9-.3-1.8-1.3l1-6.1c.1-.4-.1-.8-.3-1.1l-4.4-4.3c-.7-.7-.3-1.9.7-2.1l6.1-.9c.4-.1.7-.3.9-.7l2.7-5.6c.5-.8 1.8-.8 2.2.1Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.022
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel9);
export default __webpack_public_path__ + "static/media/level9.9917d1ec.svg";
export { ForwardRef as ReactComponent };